export default class ConnectorType {
  static get YandexFood () {
    return 'yandex_food'
  }

  static get Kuper () {
    return 'kuper'
  }

  static get Chibis () {
    return 'chibis'
  }

  static getName (enumValue) {
    switch (enumValue) {
      case ConnectorType.YandexFood:
        return 'Яндекс Еда'

      case ConnectorType.Kuper:
        return 'Купер'

      case ConnectorType.Chibis:
        return 'Чиббис'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      ConnectorType.YandexFood,
      ConnectorType.Chibis,
      ConnectorType.Kuper,
    ]

    return variants.map((item) => ({
      value: item,
      name: ConnectorType.getName(item),
    }))
  }
}
